import React from "react";
import { Filter, X } from "lucide-react";
import DatePickerInput from "../common/DatePickerInput";

/**
 * Professional activity filters with responsive grid
 */
const ActivityFilters = ({
  selectedType,
  setSelectedType,
  dateFrom,
  setDateFrom,
  dateTo,
  setDateTo,
  statusFilter,
  setStatusFilter,
  attemptFilter,
  setAttemptFilter,
  activityTypes,
  onFilterChange,
  onReset,
  hasActiveFilters,
}) => {
  const handleFilterChange = (setter, value) => {
    setter(value);
    onFilterChange();
  };

  // ✅ Format picker Date object to "YYYY-MM-DD" using LOCAL time (no UTC shift)
  const formatLocalDate = (date) => {
    if (!date) return "";
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, "0");
    const d = String(date.getDate()).padStart(2, "0");
    return `${y}-${m}-${d}`;
  };

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
      {/* Header */}
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-2">
          <Filter className="w-5 h-5 text-gray-600" />
          <h3 className="text-lg font-semibold text-gray-900">
            Filter Activities
          </h3>
        </div>

        {hasActiveFilters && (
          <button
            onClick={onReset}
            className="
              inline-flex items-center gap-1.5 px-3 py-1.5
              text-sm font-medium text-gray-700
              bg-gray-100 hover:bg-gray-200
              rounded-lg transition-colors duration-200
              focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-offset-2
            "
          >
            <X className="w-4 h-4" />
            Clear Filters
          </button>
        )}
      </div>

      {/* Filters Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {/* Activity Type */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1.5">
            Activity Type
          </label>
          <select
            value={selectedType}
            onChange={(e) =>
              handleFilterChange(setSelectedType, e.target.value)
            }
            className="
              w-full px-4 py-2.5 text-sm
              bg-white border border-gray-300 rounded-lg
              focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent
            "
          >
            <option value="">All Types</option>
            {activityTypes.map((type) => (
              <option key={type} value={type}>
                {type}
              </option>
            ))}
          </select>
        </div>

        {/* Date From */}
        <DatePickerInput
          label="From Date"
          selected={dateFrom ? new Date(dateFrom) : null}
          onChange={(date) => {
            handleFilterChange(setDateFrom, formatLocalDate(date));
          }}
          placeholder="Select from date"
          maxDate={new Date()}
        />

        {/* Date To */}
        <DatePickerInput
          label="To Date"
          selected={dateTo ? new Date(dateTo) : null}
          onChange={(date) => {
            handleFilterChange(setDateTo, formatLocalDate(date));
          }}
          placeholder="Select to date"
          maxDate={new Date()}
        />

        {/* Status Filter */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1.5">
            Status
          </label>
          <select
            value={statusFilter}
            onChange={(e) =>
              handleFilterChange(setStatusFilter, e.target.value)
            }
            className="
              w-full px-4 py-2.5 text-sm
              bg-white border border-gray-300 rounded-lg
              focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent
            "
          >
            <option value="">All Statuses</option>
            <option value="Approved">Approved</option>
            <option value="Rejected">Rejected</option>
          </select>
        </div>

        {/* Attempt Type Filter */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1.5">
            Attempt Type
          </label>
          <select
            value={attemptFilter}
            onChange={(e) =>
              handleFilterChange(setAttemptFilter, e.target.value)
            }
            className="
              w-full px-4 py-2.5 text-sm
              bg-white border border-gray-300 rounded-lg
              focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent
            "
          >
            <option value="">All Attempts</option>
            <option value="First(F)">First (F)</option>
            <option value="Repeat(R)">Repeat (R)</option>
            <option value="Remedial(Re)">Remedial (Re)</option>
          </select>
        </div>
      </div>
    </div>
  );
};

export default ActivityFilters;

//10
